import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36b2539d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2539d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b2539d')) {
      api.createRecord('36b2539d', component.options)
    } else {
      api.reload('36b2539d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36b2539d&scoped=true&", function () {
      api.rerender('36b2539d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaFit/index.vue"
export default component.exports